import { api } from '@/core/api/';
import qs from 'querystring';
const apiUrl = 'api/referralsandequipments';

export default {
  getAcademicyears() {
    return api.get(`${apiUrl}/academicyears`);
  },
  getStatuses() {
    return api.get(`${apiUrl}/servicestatus`);
  },
  getEquipmentStatuses() {
    return api.get(`${apiUrl}/equipment/statuses`);
  },
  getServiceTypes() {
    return api.get(`${apiUrl}/referraltype`);
  },
  getClassificationServiceStatus() {
    return api.get(`${apiUrl}/classificastionservicestatus`);
  },
  search(params) {
    return api.get(`${apiUrl}/search`, { params: { ...params } });
  },
  searchEquipments(params) {
    return api.get(`${apiUrl}/searchequipments`, {
      params: { ...params },
      paramsSerializer: (q) => {
        const propsWithValues = Object.entries(q).reduce(
          (acc, [key, value]) => {
            if (value !== undefined) acc[key] = value;
            return acc;
          },
          {}
        );
        return qs.stringify(propsWithValues);
      },
    });
  },
  updateReferralType(id, referralTypeId) {
    return api.put(`${apiUrl}/${id}/referraltype/${referralTypeId}`);
  },
  getAdditionalInfo(id) {
    return api.get(`${apiUrl}/referral/${id}/additionalinfo`);
  },
  getSifdeRequestInfo(id) {
    return api.get(`${apiUrl}/equipment/recommendation/${id}/sifderequestinfo`);
  },
  getActualSchoolInfo(id) {
    return api.get(`${apiUrl}/referral/${id}/actualschoolinfo`);
  },
  getStatusLog(id) {
    return api.get(`${apiUrl}/peiatservicesstatus/${id}`);
  },
  getEquipmentStatusLog(id) {
    return api.get(`${apiUrl}/peiatequipmentservicesstatus/${id}`);
  },
  updateCaatType(id, caatId) {
    return api.put(`${apiUrl}/${id}/caattype/${caatId}`);
  },
  saveBinnacle(payload) {
    return api.post(`${apiUrl}/addbinacle`, payload);
  },
  saveEquipmentBinnacle(payload) {
    return api.post(`${apiUrl}/addequipmentbinacle`, payload);
  },
  saveRecomendationRequestSidfe(payload) {
    return api.post(`${apiUrl}/saverecomendationrequestsidfe`, payload);
  },
  getBinnacle(params) {
    return api.get(`${apiUrl}/binnacles`, { params: { ...params } });
  },
  getAppointmentLog(id) {
    return api.get(`${apiUrl}/appointmentlog/${id}`);
  },
  getAppointmentByStatus(id, statusId) {
    return api.get(`${apiUrl}/appointment/${id}/${statusId}`);
  },
  changeStatus(id, model) {
    return api.put(`${apiUrl}/${id}/changestatus`, model);
  },

  getAllParticipants(query) {
    return api.get(`${apiUrl}/allparticipants?query=${query}`);
  },
  getCaatByParticipants(userId) {
    return api.get(`${apiUrl}/caatbyparticipant/${userId}`);
  },
  coordinateAppointment(data) {
    return api.post(`${apiUrl}/coordinateAppointment`, data);
  },
  getOrderAndEquipmentInfo(id) {
    return api.get(`${apiUrl}/equipment/${id}/orderandequipmentinfo`);
  },
  getAbsenceStatusReasons() {
    return api.get(`${apiUrl}/absencetatusreasons`);
  },
  getReasonsByType(reasonTypeId) {
    return api.get(`${apiUrl}/reasons/${reasonTypeId}`);
  },
  saveAppointmentAbsence(data) {
    return api.post(`${apiUrl}/registerabsence`, data);
  },
  getReferralSummary(id) {
    return api.get(`${apiUrl}/referral/${id}/summary`);
  },
  getEquipmentRecommendationSummary(id) {
    return api.get(`${apiUrl}/equipment/recommendation/${id}/summary`);
  },
  getEquipmentsClassified(id) {
    return api.get(`${apiUrl}/referral/${id}/equipments/classified`);
  },
  getEquipmentsPendingClassification(id) {
    return api.get(`${apiUrl}/referral/${id}/equipments/pendingclassification`);
  },
  getServicesByReferralId(id) {
    return api.get(`${apiUrl}/referral/${id}/services`);
  },
  getEquipmentClassifications() {
    return api.get(`${apiUrl}/equipments/classifications`);
  },
  getEquipmentPurchaseMethods() {
    return api.get(`${apiUrl}/equipments/purchasemethods`);
  },

  getServiceClassifications() {
    return api.get(`${apiUrl}/services/classifications`);
  },
  getStudentInfoParticipantList(isAppraise, isReferralTypeValidation) {
    return api.get(
      `${apiUrl}/participantpositionlist/13/${isAppraise}/${isReferralTypeValidation}`
    );
  },
  getATParticipants(id) {
    return api.get(`${apiUrl}/atparticipants?peiATServiceId=${id}`);
  },
  saveEvaluation(data) {
    return api.post(`${apiUrl}/saveevaluation`, data);
  },
  getReferralMedicalInfo(id) {
    return api.get(`${apiUrl}/referral/${id}/evaluation/medicalinfo`);
  },
  getSkills() {
    return api.get(`${apiUrl}/skills`);
  },
  getQuestionnaire(id, sectionId = null) {
    return api.get(`${apiUrl}/questionnaire/${id}?sectionId=${sectionId}`);
  },
  getSkillQuestionnaire(id, skillId) {
    return api.get(`${apiUrl}/skillquestionnaire/${id}/${skillId}`);
  },
  getStudentInfo(peiAtServiceId) {
    return api.get(
      `${apiUrl}/studentinformation?peiAtServiceId=${peiAtServiceId}`
    );
  },
  getEvaluationInfo(id) {
    return api.get(`${apiUrl}/EvaluationMethodList/${id}`);
  },
  getObservationsFindings(id) {
    return api.get(`${apiUrl}/referral/${id}/evaluation/observationsfindings`);
  },
  getRecommendations(id) {
    return api.get(`${apiUrl}/recommendations?id=${id}`);
  },
  getTabIIIbInfo(id) {
    return api.get(`${apiUrl}/tabIIIb/${id}`);
  },
  getServicesEvaluations(pei) {
    return api.get(`${apiUrl}/servicesevaluations/${pei}`);
  },
  saveReferralMedicalInfo(id, data) {
    return api.post(`${apiUrl}/${id}/evaluation/medicalinfo`, data);
  },
  saveStudentInfo(id, data) {
    return api.post(`${apiUrl}/${id}/evaluation/studentinfo`, data);
  },
  saveRelevantGeneralHistoryInformation(id, data) {
    return api.post(
      `${apiUrl}/${id}/evaluation/relevantgeneralhistoryinformation`,
      data
    );
  },
  saveEvaluationReportAnswer(id, data) {
    return api.post(`${apiUrl}/${id}/evaluation/observationsfindings`, data);
  },
  saveStudentRecommendations(id, data) {
    return api.post(`${apiUrl}/${id}/evaluation/recommendations`, data);
  },
  saveOtherRecommendations(id, data) {
    return api.post(`${apiUrl}/${id}/evaluation/otherrecommendations`, data);
  },
  submitEvaluation(id) {
    return api.put(`${apiUrl}/${id}/evaluation/submit`);
  },
  uploadFileEvaluation(id, data) {
    return api.post(`${apiUrl}/uploadevaluation/${id}`, data);
  },
  getFileEvaluationInfo(id) {
    return api.get(`${apiUrl}/evaluationservicedocument/${id}`);
  },
  deleteFileEvaluationInfo(id) {
    return api.delete(`${apiUrl}/evaluationservicedocument/${id}`);
  },
  editEvaluation(id) {
    return api.put(`${apiUrl}/${id}/evaluation/edit`);
  },
  rejectReferral(data) {
    return api.put(`${apiUrl}/rejectreferral`, data);
  },
  getRejectReasons() {
    return api.get(`${apiUrl}/rejectreasonlist`);
  },
  getEquipmentBinnacles(params) {
    return api.get(`${apiUrl}/equipmentbinnacles`, { params: { ...params } });
  },
  getOtherRecommendationsComments(id) {
    return api.get(`${apiUrl}/${id}/evaluation/otherrecommendationscomments`);
  },
  getAjustmentReasons() {
    return api.get(`${apiUrl}/ajustmentreasonlist`);
  },
  ajustReferral(data) {
    return api.put(`${apiUrl}/ajustreferral`, data);
  },
  getDocuments(peiAtServiceId) {
    return api.get(`${apiUrl}/documents/${peiAtServiceId}`);
  },
  saveEquipmentRecommendation(data) {
    return api.post(`${apiUrl}/requisitionanalysis/save`, data);
  },
  saveDocumentDate(data) {
    return api.post(`${apiUrl}/documentdate`, data);
  },
  getReferralByNumber(referralNumber) {
    return api.get(
      `${apiUrl}/referralbynumber?referralNumber=${referralNumber}`
    );
  },
  saveReferralServices(id, data) {
    return api.post(`${apiUrl}/${id}/saveservices`, data);
  },
  getCommentClassifications() {
    return api.get(`${apiUrl}/commentclassifications`);
  },
  getServiceDocumentationMethods() {
    return api.get(`${apiUrl}/services/documentation/methods`);
  },
  saveServiceDocumentation(data) {
    return api.post(`${apiUrl}/services/documentation/save`, data);
  },
  getReferralDocument(peiAtServiceId, documentType) {
    return api.get(
      `${apiUrl}/services/${peiAtServiceId}/document/${documentType}`
    );
  },
  saveReferralDocument(peiAtServiceId, documentType, data) {
    return api.post(
      `${apiUrl}/services/${peiAtServiceId}/document/${documentType}/save`,
      data
    );
  },
  getRequisitionsDocuments(peiAtServiceId) {
    return api.get(`${apiUrl}/${peiAtServiceId}/requisitions-documents`);
  },
  getEquipmentUsageGuaranteeDocument(params) {
    return api.get(`${apiUrl}/searchguaranteedocuments`, {
      params: { ...params },
    });
  },
};
